export const GA_MEASUREMENT_ID = 'G-8MZ3GZEGVP';

const isBrowser = () => typeof window !== 'undefined';
const hasGtag = () => isBrowser() && typeof window.gtag === 'function';

const cleanParams = (params = {}) => Object.fromEntries(
  Object.entries(params).filter(([, value]) => value !== undefined && value !== null && value !== '')
);

export function trackPageView(path, title) {
  if (!hasGtag()) return;
  const pagePath = path || `${window.location.pathname}${window.location.search}`;
  window.gtag('config', GA_MEASUREMENT_ID, cleanParams({
    page_path: pagePath,
    page_title: title || document.title,
    page_location: `${window.location.origin}${pagePath}`,
  }));
}

export function trackEvent(name, params = {}) {
  if (!hasGtag() || !name) return;
  window.gtag('event', name, cleanParams({
    app_name: 'VegasLobby',
    ...params,
  }));
}

export function setAnalyticsUser(user, tenantSlug) {
  if (!hasGtag()) return;
  if (!user?.id) {
    window.gtag('set', { user_id: null });
    return;
  }

  window.gtag('set', { user_id: user.id });
  window.gtag('set', 'user_properties', cleanParams({
    role: user.role || 'player',
    tenant_slug: tenantSlug || user.tenant_slug || 'main',
    email_verified: Boolean(user.email_verified),
  }));
}
